import React from 'react'

import { LineItemTotals } from '../../../models/line-item'
import { displayRound } from '../../../filters/display-round'
import { useRegisterManager } from '../../../ng-compat/hooks'

interface Props {
  totals: LineItemTotals
}

export const LineItemTotalBasePrice: React.FC<Props> = ({ totals }) => {
  const registerManager = useRegisterManager()
  const totalBasePrice = registerManager.isTaxInclusive()
    ? totals.inclusiveBasePrice
    : totals.exclusiveBasePrice
  return <>{displayRound(totalBasePrice, 2)}</>
}
